module.exports = __webpack_public_path__ + "static/media/defaultBannerLogo.6c1dceb2.png";